export default class Accordion {
  constructor(element) {

    this.el = element;

    const accordionItem = this.el.querySelector(".accordion-item");
    if (!accordionItem) {
      console.warn('[Accordion] Expected a ".accordion-item" descendant, found none - skipping init.', this.el);
      return;
    }

    this.id = accordionItem.getAttribute("data-id");
    this.init();
  }

  init() {
    this.el.querySelectorAll('*[data-id="' + this.id + '"] > .accordion-item__header').forEach(item => {

      const content = item.parentNode.querySelector('*[data-id="' + this.id + '"] .accordion-item__content');

      item.setAttribute('aria-expanded', 'false');

      // Checks the intended state on transitionend, so a close triggered mid-open (or vice versa) can't get overridden.
      content.addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'height') return;
        if (item.getAttribute('aria-expanded') === 'true') {
          content.style.height = 'auto';
        }
      });

      item.addEventListener('click', () => {
        const isOpen = item.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          this.close(content);
        } else {
          this.open(content);
        }

        item.setAttribute('aria-expanded', String(!isOpen));
        item.classList.toggle('accordion-item__header-visible');
      });
    });
  }

  open(content) {
    content.style.height = content.scrollHeight + 'px';
  }

  close(content) {
    // Freeze "auto" into a fixed height first, so there's something to transition from.
    content.style.height = content.scrollHeight + 'px';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
    });
  }
}